// extracted by mini-css-extract-plugin
export var quantityInput = "_fj-0";